import EsusView from 'components/esus/EsusView'

export default function CadastroIndividualView() {
  return <EsusView url='/pec/user/relatorios/consolidados/cadastroIndividual' />
}
